/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 142);
/******/ })
/************************************************************************/
/******/ ({

/***/ 142:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__App_fs__ = __webpack_require__(143);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "options", function() { return __WEBPACK_IMPORTED_MODULE_0__App_fs__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "app", function() { return __WEBPACK_IMPORTED_MODULE_0__App_fs__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "button", function() { return __WEBPACK_IMPORTED_MODULE_0__App_fs__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "renderer", function() { return __WEBPACK_IMPORTED_MODULE_0__App_fs__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "onPlayVideo", function() { return __WEBPACK_IMPORTED_MODULE_0__App_fs__["c"]; });


/***/ }),

/***/ 143:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return options; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return app; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return button; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return renderer; });
/* harmony export (immutable) */ __webpack_exports__["c"] = onPlayVideo;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_PIXI__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_PIXI___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_PIXI__);

var options = {
    backgroundColor: 0,
    transparent: true
};
var app = new __WEBPACK_IMPORTED_MODULE_0_PIXI__["Application"](800, 600, options);
document.body.appendChild(app.view);
var button = new __WEBPACK_IMPORTED_MODULE_0_PIXI__["Graphics"]().beginFill(0, 0.5).drawRoundedRect(0, 0, 100, 100, 10).endFill().beginFill(16777215).moveTo(36, 30).lineTo(36, 70).lineTo(70, 50);
var renderer = app.renderer;
button.x = (renderer.width - button.width) / 2;
button.y = (renderer.height - button.height) / 2;
button.interactive = true;
button.buttonMode = true;
app.stage.addChild(button);
function onPlayVideo() {
    button.destroy();
    var texture = __WEBPACK_IMPORTED_MODULE_0_PIXI__["Texture"].fromVideo("../img/testVideo.mp4");
    var videoSprite = new __WEBPACK_IMPORTED_MODULE_0_PIXI__["Sprite"](texture);
    videoSprite.width = renderer.width;
    videoSprite.height = renderer.height;
    app.stage.addChild(videoSprite);
}
button.on("pointertap", function () {
    onPlayVideo();
});

/***/ }),

/***/ 16:
/***/ (function(module, exports) {

module.exports = PIXI;

/***/ })

/******/ });


// WEBPACK FOOTER //
// video/bundle.js